import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { FeatureService } from "../services/FeatureService"
import { useZuAbschlag } from "./hooks/ZuAbschlag"
import { RechnungZuschlagView } from "./RechnungZuschlagView"
import { useStoreRechnung } from "../store"

export function RechnungZuschlaegeView() {
    const { rechnungZuschlaege } = useStoreRechnung("rechnungZuschlaege")

    const { add, remove, onChange } = useZuAbschlag(rechnungZuschlaege, "rechnungZuschlaege")
    const { t } = useTranslation()
    const disabled = FeatureService.isFeatureActive("DEMO")

    return (
        <Components.Collapsible title={t("rechnung.rechnungZuschlaege.title")} collapsed={true}>
            {rechnungZuschlaege.map((a, idx) => (
                <RechnungZuschlagView key={idx} index={idx} abschlag={a} onRemove={remove} onChange={onChange} />
            ))}

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("rechnung.rechnungZuschlaege.hinzufuegen")}
                        onClick={add}
                        disabled={disabled}
                        tooltip={disabled ? t("demoversion.nicht.aktiv.hinweis") : ""}
                        tooltipAtDisabled={disabled}
                    />
                </Components.Col>
            </Components.Row>
        </Components.Collapsible>
    )
}
